import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import {
	DocumentsList,
	DocumentsListSkeleton,
} from "@/features/documents/components/documents-list";
import { UploadDialog } from "@/features/documents/components/upload-dialog";
import { useActiveObra } from "@/features/stages/hooks/use-active-obra.ts";
import { usePermissions } from "@/hooks/use-permissions.ts";

export function DocumentsPage() {
	const { has, isLoading: permsLoading } = usePermissions();
	const {
		obra,
		isLoading: obraLoading,
		isError: obraError,
		refetch: refetchObra,
	} = useActiveObra();

	const canCreate = has("documents:create");

	function body() {
		if (obraError) {
			return (
				<Card>
					<CardContent className="card-state">
						<p>Não foi possível carregar a obra.</p>
						<Button variant="outline" onClick={() => refetchObra()}>
							Tentar novamente
						</Button>
					</CardContent>
				</Card>
			);
		}
		if (permsLoading || obraLoading || !obra) {
			return <DocumentsListSkeleton />;
		}
		return (
			<DocumentsList
				constructionId={obra.id}
				canView={has("documents:view")}
				canUpdate={has("documents:update")}
				canDelete={has("documents:delete")}
			/>
		);
	}

	return (
		<div className="documents-page" data-slot="documents-page">
			<div className="page-header">
				<div>
					<h1 className="page-title">Documentos</h1>
					<p className="page-subtitle">
						Projetos, ART/RRT, laudos, contratos e licenças da obra.
					</p>
				</div>
				<div className="page-header__actions">
					{obra && canCreate && <UploadDialog constructionId={obra.id} />}
				</div>
			</div>

			{body()}
		</div>
	);
}
